module.exports = __webpack_public_path__ + "img/pattern-primary.214c3a8.png";